import { struct } from 'io-ts/Decoder';

import { Id as UserId } from '../../../../../user/Id';

export const Request = struct({
	user: struct({
		id: UserId,
	}),
});
